import React from "react";
import { useTranslation } from "react-i18next";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { tr } from "date-fns/esm/locale";
import { Select, MenuItem } from "@mui/material";

export default function DateInterval(props) {
    const { t } = useTranslation("translation");
    return (
        <LocalizationProvider id="LocalizationProvider_1" dateAdapter={AdapterDateFns} locale={tr}>
            <Select id="pmtl_TimeFilter" label={t("Time")} value={props.selectedTimeInterval} onChange={props.HandleTimeInterval} size={props.size}>
                {props.timeIntervals.map((data) => (
                    <MenuItem key={data.id} value={data.id}>
                        {data.name}
                    </MenuItem>
                ))}
            </Select>
        </LocalizationProvider>
    );
}
